import { all, fork } from 'redux-saga/effects';
import { watchCreateSpaceInProjectTemplateSaga } from './create';
import { watchDeleteSpaceInProjectTemplateSaga } from './delete';
import { watchsetupSpacesForProjectTemplateSaga } from './phase-space-setup';
import { watchUpdateSpaceInProjectTemplateSaga } from './update';
export function* spaceTemplateRootSaga() {
    yield all([
        fork(watchCreateSpaceInProjectTemplateSaga),
        fork(watchUpdateSpaceInProjectTemplateSaga),
        fork(watchDeleteSpaceInProjectTemplateSaga),
        fork(watchsetupSpacesForProjectTemplateSaga)
    ]);
}
